import { type API, type TRequestsHandler } from '~/utils/requestsProcessor/types';

export class NftImpl {
  constructor(private readonly makeRequest: TRequestsHandler) {}

  /** POST /nft/generate */
  public postNftGenerate(body: {
    nftToken: 'string';
    startImageNumber: 'string';
    endImageNumber: 'string';
    totalOptions: 'string';
    totalParts: 'string';
  }) {
    // Returns image URL
    return this.makeRequest<string>(`nft/generate`, { method: 'POST', body });
  }

  /** POST /v1/nft/generate */
  public postV1NftGenerate(body: API.GenerateImagesRequest) {
    return this.makeRequest<API.GenerateImagesResponse>(`v1/nft/generate`, {
      method: 'POST',
      body
    });
  }

  /** GET /nft/metadata/{key}/{id} */
  public getNftMetadataByKeyById(key: string, id: string) {
    return this.makeRequest<API.GetNftMetadataByKeyIdResponse>(
      `nft/metadata/${encodeURIComponent(String(key))}/${encodeURIComponent(String(id))}`,
      {
        method: 'GET'
      }
    );
  }
}
